<template>
  
  <div class="main-component bg-white shadow-sm rounded py-3 ps-4 pe-2 mt-2" v-if="configData && configData.bot_username == 'bystrokurs_bot'">
    <h1>Быстрокурс</h1>
    <p>Платформа для создания и проведения быстрокурсов в Telegram c бесплатным хранилищем и защитой контента.</p>

    <p>Посмотрите короткое видео, чтобы узнать, как создавать курсы в платформе «Быстрокурс» с автоматическим созданием контента из видео и настройкой приема платежей.</p>
    <div>
      <a href="https://www.youtube.com/playlist?list=PL-jGSgsIvr_p_YLcJ6F0M0vn_5rIH0u0r" class="btn btn-primary mt-2" target="_blank">Смотреть видео-инструкцию</a> 
      <a href="https://t.me/ayarmots" class="btn btn-light mt-2 ms-2" target="_blank">Написать разработчику</a> 
    </div>

    <p v-if="!isAuthenticated">Войдите, чтобы начать пользоваться платформой.</p>


    <telegram-auth v-if="!isAuthenticated && !configData.disable_telegram_auth"></telegram-auth>

    <div v-if="isAuthenticated">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mt-3">
        <!-- Loop for existing channels -->
        <div v-for="channel in channels" :key="channel.id" class="col">
          <div class="card h-100">
            <img :src="channel.logo_square_thumbs.middle" class="card-img-top img-fluid" :alt="channel.caption" v-if="channel.logo_square_thumbs.middle">
            <img :src="channelCoverUrl" class="card-img-top img-fluid" :alt="channel.caption" v-if="!channel.logo_square_thumbs.middle">

            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ channel.caption }}</h5>

              <a :href="channel.link" class="btn btn btn-primary">Открыть</a>

              <!-- You can add more information about the channel here -->
              <!-- For example: -->
              <!-- <p class="card-text">{{ channel.description }}</p> -->
              <!-- <p class="card-text"><small class="text-muted">Last updated {{ channel.lastUpdated }}</small></p> -->
            </div>
          </div>
        </div>
        
        <!-- Card for creating a channel -->
        <div class="col">
          <div class="card h-100">
            <img :src="addCoverUrl" class="card-img-top img-fluid" alt="">
            <div class="card-body d-flex flex-column justify-content-center">
              <h5 class="card-title">Создать канал</h5>
              <p class="card-text">Нажмите здесь, чтобы создать новый канал.</p>
              <!-- You can add a button or link to trigger the creation of a new channel -->

              <router-link to="/channels">
                <button class="btn btn btn-primary">Создать канал</button>
              </router-link>
              <div>
                <a :href="'https://t.me/' + configData.bot_username" class="btn btn-outline-primary mt-3" target="_blank" v-if="isAuthenticated">Открыть в Telegram</a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    
  </div>

 <div class="main-component bg-white shadow-sm rounded py-3 ps-4 pe-2 mt-2" v-if="configData && configData.bot_username == 'harikatha_bot'">
    <h1>Хари Катха</h1>
    <p>«Хари Катха» — это место, где мы собираем вдохновляющие лекции проповедников традиции бхакти-йоги, чтобы помочь вам углубить свои знания. </p>
    <p>Мы не просто предлагаем видео — каждую лекцию сопровождают текстовые конспекты и выжимки, а тесты для самопроверки помогут закрепить понимание. Всё сделано для того, чтобы ваше духовное обучение было глубоким, системным и удобным.</p>

    <p>
      <b>Платформа «Хари Катха» предлагает:</b>
      <ul>
        <li><b>Удобный глобальный поиск по темам</b> — найдите, где в лекциях разных учителей упоминаются интересующие вас вопросы.</li>
        <li><b>Текстовые конспекты и выжимки</b> — ключевые моменты лекций для быстрого восприятия информации.</li>
        <li><b>Тесты для самопроверки</b> — чтобы вы могли убедиться в усвоении материала.</li>
        <li><b>Лекции различных проповедников</b>, представленных на одной платформе, с возможностью предлагать новых учителей.</li>
      </ul>
    </p>


    <div class="row mb-3 mt-5">
      <div class="col-12">
        <SearchBarComponent searchType="global"/>
      </div>
    </div>


    <div >
      <div class="row row-cols-1 row-cols-md-3 g-4 mt-3" :class="(menuVisible)?'row-cols-lg-3': 'row-cols-lg-4'">
        <!-- Loop for existing channels -->
        <div v-for="channel in channels" :key="channel.id" class="col">
          <div class="card h-100">
            <img :src="channel.logo_square_thumbs.middle" class="card-img-top img-fluid" :alt="channel.caption" v-if="channel.logo_square_thumbs.middle">
            <img :src="channelCoverUrl" class="card-img-top img-fluid" :alt="channel.caption" v-if="!channel.logo_square_thumbs.middle">

            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ channel.caption }}</h5>
              <div class="small d-flex align-items-center mb-2" ><span class="badge bg-primary">{{ channel.stats.total.count }} видео</span> <span class="text-muted ps-2"><i class="bi bi-clock"></i> {{channel.stats.total.duration_hours}}</span></div>
              <div class="progress">

                  <div class="progress-bar bg-success" role="progressbar" 
                       :style="{ width: channel.stats.progress + '%' }">
                  </div>
              </div>
              <div class="small text-muted">
                {{ channel.stats.processed.count }} из {{ channel.stats.total.count }} обработано
              </div>


<!--               <p class="card-text">Обработано видео {{ channel.stats.processed.count }} из  {{ channel.stats.total.count }}</p>
              <p class="card-text">Оплачено {{ channel.stats.processed.sum }} из  {{ channel.stats.total.sum }}</p>
 -->
              <a :href="channel.link" class="btn btn btn-primary mt-3">Открыть</a>

              <!-- You can add more information about the channel here -->
              <!-- For example: -->
              <!-- <p class="card-text">{{ channel.description }}</p> -->
              <!-- <p class="card-text"><small class="text-muted">Last updated {{ channel.lastUpdated }}</small></p> -->
            </div>
          </div>
        </div>
        
        <!-- Card for creating a channel -->
        <div class="col" v-if="isAuthenticated">
          <div class="card h-100">
            <img :src="addCoverUrl" class="card-img-top img-fluid" alt="">
            <div class="card-body d-flex flex-column justify-content-center">
              <h5 class="card-title">Создать канал</h5>
              <p class="card-text">Нажмите здесь, чтобы создать новый канал.</p>
              <!-- You can add a button or link to trigger the creation of a new channel -->

              <router-link to="/channels">
                <button class="btn btn btn-primary">Создать канал</button>
              </router-link>
              <div>
                <a :href="'https://t.me/' + configData.bot_username" class="btn btn-outline-primary mt-3" target="_blank" v-if="isAuthenticated">Открыть в Telegram</a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <p v-if="!isAuthenticated" class="mt-4">Войдите, чтобы начать пользоваться платформой.</p>
    <telegram-auth v-if="!isAuthenticated && !configData.disable_telegram_auth"></telegram-auth>

    
  </div> 

  <!-- Chaitanya Academy -->
  <div class="main-component bg-white shadow-sm rounded py-3 ps-4 pe-2 mt-2" v-if="configData && configData.bot_username == 'ChaitanyaAcademy_bot'">
    <h1>Чайтанья Академия</h1>
    <p>Добро пожаловать в академическую библиотеку духовных знаний! Здесь собраны лекции ведущих наставников традиции бхакти-йоги с подробными конспектами и возможностями для глубокого изучения.</p>
    <p>Наша миссия — предоставить систематизированный доступ к мудрости священных текстов и комментариев великих учителей для серьезного духовного образования.</p>

    <p>
      <b>Возможности Академии:</b>
      <ul>
        <li><b>Академическая глубина</b> — детальные разборы философских концепций и священных текстов.</li>
        <li><b>Структурированное обучение</b> — материалы организованы для последовательного изучения.</li>
        <li><b>Поиск по ключевым понятиям</b> — найдите объяснения важных терминов и концепций.</li>
        <li><b>Конспекты и тезисы</b> — краткие выжимки для быстрого повторения материала.</li>
      </ul>
    </p>


    <div class="row mb-3 mt-4">
      <div class="col-12">
        <SearchBarComponent searchType="global"/>
      </div>
    </div>

    <div>
      <div class="row row-cols-1 row-cols-md-3 g-4 mt-3" :class="(menuVisible)?'row-cols-lg-3': 'row-cols-lg-4'">
        <!-- Loop for existing channels -->
        <div v-for="channel in channels" :key="channel.id" class="col">
          <div class="card h-100">
            <img :src="channel.logo_square_thumbs.middle" class="card-img-top img-fluid" :alt="channel.caption" v-if="channel.logo_square_thumbs.middle">
            <img :src="channelCoverUrl" class="card-img-top img-fluid" :alt="channel.caption" v-if="!channel.logo_square_thumbs.middle">

            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ channel.caption }}</h5>
              <div class="small d-flex align-items-center mb-2"><span class="badge bg-primary">{{ channel.stats.total.count }} материалов</span> <span class="text-muted ps-2"><i class="bi bi-clock"></i> {{channel.stats.total.duration_hours}}</span></div>
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar" 
                     :style="{ width: channel.stats.progress + '%' }">
                </div>
              </div>
              <div class="small text-muted">
                {{ channel.stats.processed.count }} из {{ channel.stats.total.count }} обработано
              </div>

              <a :href="channel.link" class="btn btn btn-primary mt-3">Открыть</a>
            </div>
          </div>
        </div>
        
        <!-- Card for creating a channel -->
        <div class="col" v-if="isAuthenticated">
          <div class="card h-100">
            <img :src="addCoverUrl" class="card-img-top img-fluid" alt="">
            <div class="card-body d-flex flex-column justify-content-center">
              <h5 class="card-title">Создать канал</h5>
              <p class="card-text">Нажмите здесь, чтобы создать новый канал.</p>

              <router-link to="/channels">
                <button class="btn btn btn-primary">Создать канал</button>
              </router-link>
              <div>
                <a :href="'https://t.me/' + configData.bot_username" class="btn btn-outline-primary mt-3" target="_blank" v-if="isAuthenticated">Открыть в Telegram</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p v-if="!isAuthenticated" class="mt-4">Войдите, чтобы начать пользоваться платформой.</p>
    <telegram-auth v-if="!isAuthenticated && !configData.disable_telegram_auth"></telegram-auth>
  </div>

  <!-- MeetScribe -->
  <div class="meetscribe-landing" v-if="configData && configData.service_name === 'meetscribe'">

    <!-- Hero Section -->
    <div class="ms-hero">
      <div class="ms-hero-content">
        <div class="ms-hero-badge">
          <i class="bi bi-stars"></i>
          <span>{{ $t('meetscribe.home.badge') || 'AI-powered' }}</span>
        </div>
        <h1 class="ms-hero-title">MeetScribe</h1>
        <p class="ms-hero-subtitle">{{ $t('meetscribe.home.subtitle') || 'AI-платформа для расшифровки встреч и записей' }}</p>
        <p class="ms-hero-description">{{ $t('meetscribe.home.description') || 'Загрузите аудио или видео — получите готовый протокол с задачами, решениями и ключевыми моментами' }}</p>

        <div class="ms-hero-actions">
          <router-link to="/meetings" class="ms-btn ms-btn-primary">
            <i class="bi bi-play-circle"></i>
            {{ $t('meetscribe.home.cta_meetings') || 'Мои встречи' }}
          </router-link>
          <a :href="'https://t.me/' + (configData.bot_username || 'meetscribe_bot')" target="_blank" class="ms-btn ms-btn-secondary">
            <i class="bi bi-telegram"></i>
            {{ $t('meetscribe.home.cta_bot') || 'Открыть бота' }}
          </a>
        </div>
      </div>
      <div class="ms-hero-visual">
        <div class="ms-visual-card">
          <div class="ms-visual-header">
            <span class="ms-visual-dot red"></span>
            <span class="ms-visual-dot yellow"></span>
            <span class="ms-visual-dot green"></span>
          </div>
          <div class="ms-visual-content">
            <div class="ms-visual-line title"></div>
            <div class="ms-visual-line"></div>
            <div class="ms-visual-line short"></div>
            <div class="ms-visual-tasks">
              <div class="ms-visual-task"><i class="bi bi-check-circle-fill"></i></div>
              <div class="ms-visual-task"><i class="bi bi-circle"></i></div>
              <div class="ms-visual-task"><i class="bi bi-circle"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div class="ms-section">
      <h2 class="ms-section-title">{{ $t('meetscribe.home.how_it_works') || 'Как это работает' }}</h2>
      <div class="ms-steps">
        <div class="ms-step">
          <div class="ms-step-number">1</div>
          <div class="ms-step-icon"><i class="bi bi-upload"></i></div>
          <h4>{{ $t('meetscribe.home.step1_title') || 'Загрузите запись' }}</h4>
          <p>{{ $t('meetscribe.home.step1_desc') || 'Отправьте аудио или видео файл в Telegram бота или загрузите через веб-интерфейс' }}</p>
        </div>
        <div class="ms-step-arrow"><i class="bi bi-arrow-right"></i></div>
        <div class="ms-step">
          <div class="ms-step-number">2</div>
          <div class="ms-step-icon"><i class="bi bi-cpu"></i></div>
          <h4>{{ $t('meetscribe.home.step2_title') || 'AI обработка' }}</h4>
          <p>{{ $t('meetscribe.home.step2_desc') || 'Система транскрибирует речь и анализирует содержание встречи' }}</p>
        </div>
        <div class="ms-step-arrow"><i class="bi bi-arrow-right"></i></div>
        <div class="ms-step">
          <div class="ms-step-number">3</div>
          <div class="ms-step-icon"><i class="bi bi-file-earmark-text"></i></div>
          <h4>{{ $t('meetscribe.home.step3_title') || 'Готовый протокол' }}</h4>
          <p>{{ $t('meetscribe.home.step3_desc') || 'Получите структурированный протокол с задачами, решениями и ключевыми моментами' }}</p>
        </div>
      </div>
    </div>

    <!-- Features Grid -->
    <div class="ms-section">
      <h2 class="ms-section-title">{{ $t('meetscribe.home.features_title') || 'Возможности' }}</h2>
      <div class="ms-features-grid">
        <div class="ms-feature">
          <div class="ms-feature-icon"><i class="bi bi-mic"></i></div>
          <h4>{{ $t('meetscribe.home.feature_1') || 'Расшифровка' }}</h4>
          <p>{{ $t('meetscribe.home.feature_1_desc') || 'Автоматическая транскрипция аудио и видео с высокой точностью' }}</p>
        </div>
        <div class="ms-feature">
          <div class="ms-feature-icon"><i class="bi bi-list-task"></i></div>
          <h4>{{ $t('meetscribe.home.feature_2') || 'Задачи' }}</h4>
          <p>{{ $t('meetscribe.home.feature_2_desc') || 'Автоматическое извлечение задач и поручений из обсуждения' }}</p>
        </div>
        <div class="ms-feature">
          <div class="ms-feature-icon"><i class="bi bi-people"></i></div>
          <h4>{{ $t('meetscribe.home.feature_3') || 'Участники' }}</h4>
          <p>{{ $t('meetscribe.home.feature_3_desc') || 'Определение спикеров и их вклада в обсуждение' }}</p>
        </div>
        <div class="ms-feature">
          <div class="ms-feature-icon"><i class="bi bi-share"></i></div>
          <h4>{{ $t('meetscribe.home.feature_4') || 'Экспорт' }}</h4>
          <p>{{ $t('meetscribe.home.feature_4_desc') || 'Выгрузка протокола в Markdown, Google Docs и другие форматы' }}</p>
        </div>
      </div>
    </div>

    <!-- Quick Actions for authenticated users -->
    <div class="ms-section" v-if="isAuthenticated">
      <h2 class="ms-section-title">{{ $t('meetscribe.home.quick_actions') || 'Быстрые действия' }}</h2>
      <div class="ms-actions-grid">
        <router-link to="/meetings" class="ms-action-card">
          <div class="ms-action-icon primary"><i class="bi bi-calendar-event"></i></div>
          <div class="ms-action-content">
            <h4>{{ $t('meetscribe.home.meetings_title') || 'Мои встречи' }}</h4>
            <p>{{ $t('meetscribe.home.meetings_desc') || 'Просмотр и управление расшифровками' }}</p>
          </div>
          <i class="bi bi-chevron-right ms-action-arrow"></i>
        </router-link>

        <router-link to="/api-docs" class="ms-action-card">
          <div class="ms-action-icon green"><i class="bi bi-code-slash"></i></div>
          <div class="ms-action-content">
            <h4>{{ $t('meetscribe.home.api_title') || 'API документация' }}</h4>
            <p>{{ $t('meetscribe.home.api_desc') || 'REST API и CLI для интеграции' }}</p>
          </div>
          <i class="bi bi-chevron-right ms-action-arrow"></i>
        </router-link>

        <router-link to="/subscription" class="ms-action-card">
          <div class="ms-action-icon purple"><i class="bi bi-credit-card"></i></div>
          <div class="ms-action-content">
            <h4>{{ $t('meetscribe.home.subscription_title') || 'Подписка' }}</h4>
            <p>{{ $t('meetscribe.home.subscription_desc') || 'Управление тарифом и балансом' }}</p>
          </div>
          <i class="bi bi-chevron-right ms-action-arrow"></i>
        </router-link>
      </div>
    </div>

    <!-- Auth CTA for non-authenticated -->
    <div class="ms-auth-section" v-if="!isAuthenticated">
      <div class="ms-auth-content">
        <h3>{{ $t('meetscribe.home.auth_title') || 'Начните использовать MeetScribe' }}</h3>
        <p>{{ $t('auth.login_to_continue') || 'Войдите, чтобы начать пользоваться платформой' }}</p>
        <telegram-auth v-if="!configData.disable_telegram_auth"></telegram-auth>
      </div>
    </div>

  </div>

  <!-- ClipCut Landing Page -->
  <div class="clipcut-landing" v-if="configData && (configData.service_name === 'clipcut' || configData.service_name === 'clipcutglobal')">

    <!-- Hero Section -->
    <div class="cc-hero">
      <div class="cc-hero-content">
        <div class="cc-hero-badge">
          <i class="bi bi-scissors"></i>
          <span>{{ configData.service_name === 'clipcutglobal' ? 'AI-powered' : 'AI-нарезка' }}</span>
        </div>
        <h1 class="cc-hero-title">ClipCut</h1>
        <p class="cc-hero-subtitle">{{ configData.service_name === 'clipcutglobal' ? 'AI-powered vertical video creator' : 'AI-создание вертикальных видео' }}</p>
        <p class="cc-hero-description">{{ configData.service_name === 'clipcutglobal' ? 'Upload your video and get ready-to-publish Shorts with automatic subtitles for TikTok, Reels, and YouTube Shorts' : 'Загрузите видео — получите готовые Shorts с субтитрами для TikTok, Reels и YouTube Shorts' }}</p>

        <div class="cc-hero-actions">
          <router-link to="/materials" class="cc-btn cc-btn-primary">
            <i class="bi bi-collection-play"></i>
            {{ configData.service_name === 'clipcutglobal' ? 'My Videos' : 'Мои видео' }}
          </router-link>
          <a :href="'https://t.me/' + (configData.bot_username || 'clipcut_bot')" target="_blank" class="cc-btn cc-btn-secondary">
            <i class="bi bi-telegram"></i>
            {{ configData.service_name === 'clipcutglobal' ? 'Open Bot' : 'Открыть бота' }}
          </a>
        </div>
      </div>
      <div class="cc-hero-visual">
        <div class="cc-visual-phone">
          <div class="cc-visual-notch"></div>
          <div class="cc-visual-screen">
            <div class="cc-visual-video"></div>
            <div class="cc-visual-subtitles">
              <span>AI-generated subtitles</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div class="cc-section">
      <h2 class="cc-section-title">{{ configData.service_name === 'clipcutglobal' ? 'How it works' : 'Как это работает' }}</h2>
      <div class="cc-steps">
        <div class="cc-step">
          <div class="cc-step-number">1</div>
          <div class="cc-step-icon"><i class="bi bi-upload"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Upload Video' : 'Загрузите видео' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'Send a video file or YouTube link to the Telegram bot' : 'Отправьте видео или ссылку на YouTube в Telegram бота' }}</p>
        </div>
        <div class="cc-step-arrow"><i class="bi bi-arrow-right"></i></div>
        <div class="cc-step">
          <div class="cc-step-number">2</div>
          <div class="cc-step-icon"><i class="bi bi-scissors"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'AI Processing' : 'AI обработка' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'AI finds the best moments and creates vertical clips with subtitles' : 'ИИ находит лучшие моменты и создаёт вертикальные клипы с субтитрами' }}</p>
        </div>
        <div class="cc-step-arrow"><i class="bi bi-arrow-right"></i></div>
        <div class="cc-step">
          <div class="cc-step-number">3</div>
          <div class="cc-step-icon"><i class="bi bi-download"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Download Shorts' : 'Скачайте Shorts' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'Get ready-to-publish vertical videos for all platforms' : 'Получите готовые вертикальные видео для всех платформ' }}</p>
        </div>
      </div>
    </div>

    <!-- Features Grid -->
    <div class="cc-section">
      <h2 class="cc-section-title">{{ configData.service_name === 'clipcutglobal' ? 'Features' : 'Возможности' }}</h2>
      <div class="cc-features-grid">
        <div class="cc-feature">
          <div class="cc-feature-icon"><i class="bi bi-aspect-ratio"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Vertical Format' : 'Вертикальный формат' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'Automatic conversion to 9:16 aspect ratio' : 'Автоматическая конвертация в формат 9:16' }}</p>
        </div>
        <div class="cc-feature">
          <div class="cc-feature-icon"><i class="bi bi-chat-square-text"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Auto Subtitles' : 'Авто-субтитры' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'AI-generated captions with multiple styles' : 'ИИ-генерация субтитров с разными стилями' }}</p>
        </div>
        <div class="cc-feature">
          <div class="cc-feature-icon"><i class="bi bi-magic"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Smart Clips' : 'Умная нарезка' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'AI selects the most engaging moments' : 'ИИ выбирает самые интересные моменты' }}</p>
        </div>
        <div class="cc-feature">
          <div class="cc-feature-icon"><i class="bi bi-person-bounding-box"></i></div>
          <h4>{{ configData.service_name === 'clipcutglobal' ? 'Face Tracking' : 'Трекинг лица' }}</h4>
          <p>{{ configData.service_name === 'clipcutglobal' ? 'Automatic speaker centering' : 'Автоматическое центрирование спикера' }}</p>
        </div>
      </div>
    </div>

    <!-- Quick Actions for authenticated users -->
    <div class="cc-section" v-if="isAuthenticated">
      <h2 class="cc-section-title">{{ configData.service_name === 'clipcutglobal' ? 'Quick Actions' : 'Быстрые действия' }}</h2>
      <div class="cc-actions-grid">
        <router-link to="/materials" class="cc-action-card">
          <div class="cc-action-icon primary"><i class="bi bi-collection-play"></i></div>
          <div class="cc-action-content">
            <h4>{{ configData.service_name === 'clipcutglobal' ? 'My Videos' : 'Мои видео' }}</h4>
            <p>{{ configData.service_name === 'clipcutglobal' ? 'View and download your shorts' : 'Просмотр и скачивание шортсов' }}</p>
          </div>
          <i class="bi bi-chevron-right cc-action-arrow"></i>
        </router-link>

        <router-link to="/subscription" class="cc-action-card">
          <div class="cc-action-icon green"><i class="bi bi-credit-card"></i></div>
          <div class="cc-action-content">
            <h4>{{ configData.service_name === 'clipcutglobal' ? 'Subscription' : 'Подписка' }}</h4>
            <p>{{ configData.service_name === 'clipcutglobal' ? 'Manage your plan and balance' : 'Управление тарифом и балансом' }}</p>
          </div>
          <i class="bi bi-chevron-right cc-action-arrow"></i>
        </router-link>
      </div>
    </div>

    <!-- Auth CTA for non-authenticated -->
    <div class="cc-auth-section" v-if="!isAuthenticated">
      <div class="cc-auth-content">
        <h3>{{ configData.service_name === 'clipcutglobal' ? 'Start using ClipCut' : 'Начните использовать ClipCut' }}</h3>
        <p>{{ configData.service_name === 'clipcutglobal' ? 'Log in to access your videos and subscription' : 'Войдите, чтобы начать пользоваться платформой' }}</p>
        <telegram-auth v-if="!configData.disable_telegram_auth"></telegram-auth>
      </div>
    </div>

  </div>

</template>

<script>
import channelCover from '@/assets/channel-cover.jpg';
import addCover from '@/assets/add-cover.jpg';

import { mapGetters, mapActions, mapMutations } from 'vuex';
import { computed } from 'vue';
import { useStore } from 'vuex';
import TelegramAuth from './TelegramAuth.vue';
import SearchBarComponent from './SearchBarComponent.vue';

export default {
  name: 'MainComponent',
  props: {
    id: {
      type: String,
      required: false // Если id не обязателен, можете сделать его не обязательным
    }
  },
    
  components: {
    TelegramAuth,
    SearchBarComponent
  },
  data() {
    return {
      channelCoverUrl: channelCover,
      addCoverUrl: addCover
    };
  },


  computed: {
    ...mapGetters('channel', ['getChannelItem', 'getChannels']),
    ...mapGetters('app', ['isMobile', 'configData', 'chatbotName', 'menuVisible']), 
    channelItem: {
      get() {
        return this.getChannelItem || {};
      },
      set(value) {
        this.updateChannelItem(value);
      },
    },
    channels: {
      get() {
        return this.getChannels || [];
      },
      set(value) {
        this.$store.commit('channel/setChannels', value);
      },
    }

  },  

  methods:{
    ...mapMutations('channel', ['setChannelItem', 'setChannels']),
    ...mapActions('channel', ['fetchChannel', 'saveChannel', 'deleteChannel', 'editMaterial', 'deleteMaterial', 'getMaterialsForChannel', 'fetchChannels', 'saveChannelCoverImage', 'saveChannelLogo']),

    fetchChannels() {
      this.listLoading = true;

      this.setChannels([]);

      this.$store.dispatch('channel/fetchChannels')
        .then((data) => {
          console.log(data);
          this.setChannels(data.channels);
          this.listLoading = false;

          // Обработка успешной загрузки списка подборок
          //this.channels = data.list;
        })
        .catch((error) => {
          console.log(error);
          this.listLoading = false;
          // Обработка ошибок при загрузке списка подборок
        });
    }
  },

  created() {
    // Вызов экшена для загрузки подборки
    this.fetchChannels();
  },  

  setup() {
    
    const store = useStore();
    const isAuthenticated = computed(() => store.getters['user/isAuthenticated']);
    return {
      isAuthenticated,
    
    };
  }

};
</script>

<style scoped>
/* =====================================================
   MeetScribe Landing Page - Professional Design
   ===================================================== */
.meetscribe-landing {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Hero Section */
.ms-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, var(--yt-primary, #4F46E5) 0%, #7C3AED 100%);
  border-radius: 24px;
  margin-bottom: 3rem;
  color: white;
  position: relative;
  overflow: hidden;
}

.ms-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 80%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  pointer-events: none;
}

.ms-hero-content {
  position: relative;
  z-index: 1;
}

.ms-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.2);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
}

.ms-hero-title {
  font-size: 3rem;
  font-weight: 800;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}

.ms-hero-subtitle {
  font-size: 1.25rem;
  opacity: 0.95;
  margin: 0 0 1rem 0;
  font-weight: 500;
}

.ms-hero-description {
  font-size: 1rem;
  opacity: 0.85;
  margin: 0 0 2rem 0;
  line-height: 1.6;
}

.ms-hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.ms-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s ease;
}

.ms-btn-primary {
  background: white;
  color: var(--yt-primary, #4F46E5);
}

.ms-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.ms-btn-secondary {
  background: rgba(255,255,255,0.15);
  color: white;
  border: 1px solid rgba(255,255,255,0.3);
}

.ms-btn-secondary:hover {
  background: rgba(255,255,255,0.25);
}

/* Hero Visual */
.ms-hero-visual {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.ms-visual-card {
  background: white;
  border-radius: 16px;
  padding: 0;
  width: 280px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  transform: rotate(3deg);
  overflow: hidden;
}

.ms-visual-header {
  display: flex;
  gap: 6px;
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
}

.ms-visual-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.ms-visual-dot.red { background: #ff5f56; }
.ms-visual-dot.yellow { background: #ffbd2e; }
.ms-visual-dot.green { background: #27ca40; }

.ms-visual-content {
  padding: 20px;
}

.ms-visual-line {
  height: 12px;
  background: #e5e7eb;
  border-radius: 6px;
  margin-bottom: 10px;
}

.ms-visual-line.title {
  width: 60%;
  height: 16px;
  background: #374151;
}

.ms-visual-line.short {
  width: 40%;
}

.ms-visual-tasks {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.ms-visual-task {
  width: 36px;
  height: 36px;
  background: #f3f4f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ms-visual-task i {
  color: #10b981;
  font-size: 18px;
}

.ms-visual-task:not(:first-child) i {
  color: #d1d5db;
}

/* Section Styles */
.ms-section {
  margin-bottom: 3rem;
}

.ms-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 2rem;
  text-align: center;
}

/* Steps */
.ms-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.ms-step {
  flex: 1;
  min-width: 200px;
  max-width: 280px;
  text-align: center;
  padding: 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  position: relative;
}

.ms-step-number {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 24px;
  background: var(--yt-primary, #4F46E5);
  color: white;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ms-step-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.ms-step-icon i {
  font-size: 24px;
  color: var(--yt-primary, #4F46E5);
}

.ms-step h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.ms-step p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.5;
}

.ms-step-arrow {
  display: flex;
  align-items: center;
  color: var(--yt-text-muted, #d1d5db);
  font-size: 1.5rem;
  padding-top: 2rem;
}

/* Features Grid */
.ms-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.ms-feature {
  padding: 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  transition: all 0.2s ease;
}

.ms-feature:hover {
  border-color: var(--yt-primary, #4F46E5);
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(79, 70, 229, 0.1);
}

.ms-feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.ms-feature-icon i {
  font-size: 22px;
  color: var(--yt-primary, #4F46E5);
}

.ms-feature h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.ms-feature p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.5;
}

/* Actions Grid */
.ms-actions-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ms-action-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.ms-action-card:hover {
  border-color: var(--yt-primary, #4F46E5);
  background: var(--yt-bg-secondary, #f9fafb);
}

.ms-action-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ms-action-icon i {
  font-size: 22px;
  color: white;
}

.ms-action-icon.primary {
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
}

.ms-action-icon.green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.ms-action-icon.purple {
  background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
}

.ms-action-content {
  flex: 1;
}

.ms-action-content h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin: 0 0 0.25rem 0;
}

.ms-action-content p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
}

.ms-action-arrow {
  color: var(--yt-text-muted, #9ca3af);
  font-size: 1.25rem;
}

/* Auth Section */
.ms-auth-section {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 20px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
}

.ms-auth-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.ms-auth-content p {
  color: var(--yt-text-secondary, #6b7280);
  margin-bottom: 1.5rem;
}

/* Dark Mode */
html[data-bs-theme="dark"] .ms-hero {
  background: linear-gradient(135deg, #3730A3 0%, #5B21B6 100%);
}

html[data-bs-theme="dark"] .ms-section-title {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .ms-step,
html[data-bs-theme="dark"] .ms-feature,
html[data-bs-theme="dark"] .ms-action-card {
  background: var(--yt-bg-card, #1f2937);
  border-color: var(--yt-border-color, #374151);
}

html[data-bs-theme="dark"] .ms-step h4,
html[data-bs-theme="dark"] .ms-feature h4,
html[data-bs-theme="dark"] .ms-action-content h4 {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .ms-step p,
html[data-bs-theme="dark"] .ms-feature p,
html[data-bs-theme="dark"] .ms-action-content p {
  color: var(--yt-text-secondary, #9ca3af);
}

html[data-bs-theme="dark"] .ms-step-icon,
html[data-bs-theme="dark"] .ms-feature-icon {
  background: linear-gradient(135deg, #312e81 0%, #3730a3 100%);
}

html[data-bs-theme="dark"] .ms-step-icon i,
html[data-bs-theme="dark"] .ms-feature-icon i {
  color: #a5b4fc;
}

html[data-bs-theme="dark"] .ms-visual-card {
  background: #1f2937;
}

html[data-bs-theme="dark"] .ms-visual-header {
  background: #111827;
  border-color: #374151;
}

html[data-bs-theme="dark"] .ms-visual-line {
  background: #374151;
}

html[data-bs-theme="dark"] .ms-visual-line.title {
  background: #9ca3af;
}

html[data-bs-theme="dark"] .ms-visual-task {
  background: #374151;
}

html[data-bs-theme="dark"] .ms-auth-section {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
}

html[data-bs-theme="dark"] .ms-auth-content h3 {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .ms-action-card:hover {
  background: var(--yt-bg-tertiary, #374151);
}

/* Responsive */
@media (max-width: 992px) {
  .ms-hero {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 2rem 1.5rem;
  }

  .ms-hero-actions {
    justify-content: center;
  }

  .ms-hero-visual {
    display: none;
  }

  .ms-hero-title {
    font-size: 2.25rem;
  }
}

@media (max-width: 768px) {
  .ms-steps {
    flex-direction: column;
    align-items: center;
  }

  .ms-step {
    max-width: 100%;
  }

  .ms-step-arrow {
    transform: rotate(90deg);
    padding: 0.5rem 0;
  }

  .ms-hero-title {
    font-size: 1.75rem;
  }

  .ms-hero-subtitle {
    font-size: 1rem;
  }

  .ms-btn {
    width: 100%;
    justify-content: center;
  }
}

/* =====================================================
   ClipCut Landing Page - Professional Design
   ===================================================== */
.clipcut-landing {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Hero Section */
.cc-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #DC2626 0%, #F97316 100%);
  border-radius: 24px;
  margin-bottom: 3rem;
  color: white;
  position: relative;
  overflow: hidden;
}

.cc-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 80%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  pointer-events: none;
}

.cc-hero-content {
  position: relative;
  z-index: 1;
}

.cc-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.2);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
}

.cc-hero-title {
  font-size: 3rem;
  font-weight: 800;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}

.cc-hero-subtitle {
  font-size: 1.25rem;
  opacity: 0.95;
  margin: 0 0 1rem 0;
  font-weight: 500;
}

.cc-hero-description {
  font-size: 1rem;
  opacity: 0.85;
  margin: 0 0 2rem 0;
  line-height: 1.6;
}

.cc-hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.cc-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s ease;
}

.cc-btn-primary {
  background: white;
  color: #DC2626;
}

.cc-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.cc-btn-secondary {
  background: rgba(255,255,255,0.15);
  color: white;
  border: 1px solid rgba(255,255,255,0.3);
}

.cc-btn-secondary:hover {
  background: rgba(255,255,255,0.25);
}

/* Hero Visual - Phone Mockup */
.cc-hero-visual {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.cc-visual-phone {
  width: 200px;
  height: 400px;
  background: #1f2937;
  border-radius: 36px;
  padding: 8px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  transform: rotate(-5deg);
  position: relative;
}

.cc-visual-notch {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 24px;
  background: #1f2937;
  border-radius: 12px;
  z-index: 10;
}

.cc-visual-screen {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #374151 0%, #1f2937 100%);
  border-radius: 28px;
  overflow: hidden;
  position: relative;
}

.cc-visual-video {
  width: 100%;
  height: 70%;
  background: linear-gradient(135deg, #4B5563 0%, #374151 100%);
  position: relative;
}

.cc-visual-video::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background: rgba(255,255,255,0.3);
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.5);
}

.cc-visual-subtitles {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.7);
  padding: 8px 16px;
  border-radius: 8px;
}

.cc-visual-subtitles span {
  font-size: 10px;
  color: white;
  white-space: nowrap;
}

/* Section Styles */
.cc-section {
  margin-bottom: 3rem;
}

.cc-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 2rem;
  text-align: center;
}

/* Steps */
.cc-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cc-step {
  flex: 1;
  min-width: 200px;
  max-width: 280px;
  text-align: center;
  padding: 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  position: relative;
}

.cc-step-number {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 24px;
  background: #DC2626;
  color: white;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cc-step-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.cc-step-icon i {
  font-size: 24px;
  color: #DC2626;
}

.cc-step h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.cc-step p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.5;
}

.cc-step-arrow {
  display: flex;
  align-items: center;
  color: var(--yt-text-muted, #d1d5db);
  font-size: 1.5rem;
  padding-top: 2rem;
}

/* Features Grid */
.cc-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.cc-feature {
  padding: 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  transition: all 0.2s ease;
}

.cc-feature:hover {
  border-color: #DC2626;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(220, 38, 38, 0.1);
}

.cc-feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.cc-feature-icon i {
  font-size: 22px;
  color: #DC2626;
}

.cc-feature h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.cc-feature p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.5;
}

/* Actions Grid */
.cc-actions-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cc-action-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: var(--yt-bg-card, #fff);
  border-radius: 16px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.cc-action-card:hover {
  border-color: #DC2626;
  background: var(--yt-bg-secondary, #f9fafb);
}

.cc-action-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cc-action-icon i {
  font-size: 22px;
  color: white;
}

.cc-action-icon.primary {
  background: linear-gradient(135deg, #DC2626 0%, #F97316 100%);
}

.cc-action-icon.green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.cc-action-content {
  flex: 1;
}

.cc-action-content h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--yt-text-primary, #1f2937);
  margin: 0 0 0.25rem 0;
}

.cc-action-content p {
  font-size: 0.875rem;
  color: var(--yt-text-secondary, #6b7280);
  margin: 0;
}

.cc-action-arrow {
  color: var(--yt-text-muted, #9ca3af);
  font-size: 1.25rem;
}

/* Auth Section */
.cc-auth-section {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 100%);
  border-radius: 20px;
  border: 1px solid var(--yt-border-color, #e5e7eb);
}

.cc-auth-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--yt-text-primary, #1f2937);
  margin-bottom: 0.5rem;
}

.cc-auth-content p {
  color: var(--yt-text-secondary, #6b7280);
  margin-bottom: 1.5rem;
}

/* ClipCut Dark Mode */
html[data-bs-theme="dark"] .cc-hero {
  background: linear-gradient(135deg, #991B1B 0%, #C2410C 100%);
}

html[data-bs-theme="dark"] .cc-section-title {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .cc-step,
html[data-bs-theme="dark"] .cc-feature,
html[data-bs-theme="dark"] .cc-action-card {
  background: var(--yt-bg-card, #1f2937);
  border-color: var(--yt-border-color, #374151);
}

html[data-bs-theme="dark"] .cc-step h4,
html[data-bs-theme="dark"] .cc-feature h4,
html[data-bs-theme="dark"] .cc-action-content h4 {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .cc-step p,
html[data-bs-theme="dark"] .cc-feature p,
html[data-bs-theme="dark"] .cc-action-content p {
  color: var(--yt-text-secondary, #9ca3af);
}

html[data-bs-theme="dark"] .cc-step-icon,
html[data-bs-theme="dark"] .cc-feature-icon {
  background: linear-gradient(135deg, #7F1D1D 0%, #991B1B 100%);
}

html[data-bs-theme="dark"] .cc-step-icon i,
html[data-bs-theme="dark"] .cc-feature-icon i {
  color: #FCA5A5;
}

html[data-bs-theme="dark"] .cc-visual-phone {
  background: #111827;
}

html[data-bs-theme="dark"] .cc-auth-section {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
}

html[data-bs-theme="dark"] .cc-auth-content h3 {
  color: var(--yt-text-primary, #f9fafb);
}

html[data-bs-theme="dark"] .cc-action-card:hover {
  background: var(--yt-bg-tertiary, #374151);
}

/* ClipCut Responsive */
@media (max-width: 992px) {
  .cc-hero {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 2rem 1.5rem;
  }

  .cc-hero-actions {
    justify-content: center;
  }

  .cc-hero-visual {
    display: none;
  }

  .cc-hero-title {
    font-size: 2.25rem;
  }
}

@media (max-width: 768px) {
  .cc-steps {
    flex-direction: column;
    align-items: center;
  }

  .cc-step {
    max-width: 100%;
  }

  .cc-step-arrow {
    transform: rotate(90deg);
    padding: 0.5rem 0;
  }

  .cc-hero-title {
    font-size: 1.75rem;
  }

  .cc-hero-subtitle {
    font-size: 1rem;
  }

  .cc-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
